import React, { memo, useCallback, useState } from 'react';
import { Header } from 'shared/components/Header';
import { Footer } from 'shared/components/Footer';
import { fetchPriceData } from 'shared/api/fetchPriceData';
import { usePriceData } from 'shared/hooks/usePriceData';
import { useEffectOnMount } from '../../../shared/hooks/useEffectOnMount';
import { FirstScreen } from './components/FirstScreen';
import { CourseStructure } from './components/CourseStructure';
import { SimpleComplicated } from './components/SimpleComplicated';
import { UniquePlatform } from './components/UniquePlatform';
import { ConvenientInterface } from './components/ConvenientInterface';
import { LastScreen } from './components/LastScreen';

import { PRODUCT_NAME, TEXT } from './constants';
import styles from './Programming.module.scss';
import { ButtonBuyPlace } from '../WordsBattle/components/Buttons/types';
import { sendEvent } from '../../../shared/helpers/requests';

export const Programming = memo(function Programming() {
  const { paymentPath } = usePriceData(PRODUCT_NAME);

  useEffectOnMount(() => {
    document.title = TEXT.titles.firstScreen;
  });

  const handleBuyClick = useCallback((place: ButtonBuyPlace) => {
    sendEvent({
      eventType: 'purchase_click',
      eventInfo: JSON.stringify({ place }),
      eventSource: 'programming_landing',
    });
  }, []);

  return (
    <div className={styles.main}>
      <Header type="gray" />
      <FirstScreen onBuyClick={handleBuyClick} buyHref={paymentPath} />
      <CourseStructure />
      <SimpleComplicated />
      <UniquePlatform />
      <ConvenientInterface />
      <LastScreen onBuyClick={handleBuyClick} buyHref={paymentPath} />
      <Footer />
    </div>
  );
});
